module.exports = __webpack_public_path__ + "img/icon-error-octagon-ani.43a5a5dd.gif";